<template>
  <router-link :to="{name:'goodsDetail',query:{id:goods.products_id,type:goods.products_type}}" class="goodsTemplate" >
    <div class="imgBox">
      <img :src="goods.pic" />
      <!-- <img src="../assets/timg.png" v-if="goods.stock_num == 0" class="timg" /> -->
    </div>
    <div class="right">
      <h5>{{ goods.products_title }}</h5>
      <div class="price">
        <span class="t1" v-if="goods.price">￥{{ goods.price }}</span>
        <span class="t2" v-if="goods.price_del">￥{{ goods.price_del }}</span>
        <span>　</span>
      </div>
    </div>
  </router-link>
</template>

<style lang="less" scoped>
.goodsTemplate {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 33px 24px;
  background: #fff;
  .imgBox {
    width: 160px;
    height: 160px;
    border: 1px solid #eee;
    box-sizing: border-box;
    margin-right: 15px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .right {
    flex: 1;
    overflow: hidden;
    height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    
    h5 {
      font-size: 30px;
      color: #333;
      line-height: 36px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .price{
      font-size: 28rpx;
      .t1{
        font-size: 28px;
        color: #e42129;
      }
      .t2{
        font-size: 22px;
        color: #999;
        text-decoration: line-through;
        margin-left: 12px;
      }
    }
  }
}
</style>

<script>
export default {
  props:['goods'],
  data () {
    return {}
  }
}
</script>
